import { usageIds } from "../../../constants/usageid.js";
export var ReportConfigurationSchemaIds;
(function (ReportConfigurationSchemaIds) {
    ReportConfigurationSchemaIds["REPORT_CONFIGURATION"] = "report-config";
})(ReportConfigurationSchemaIds || (ReportConfigurationSchemaIds = {}));
export var ReportConfigurationTags;
(function (ReportConfigurationTags) {
    ReportConfigurationTags["DEFAULT"] = "default";
    ReportConfigurationTags["EXPORT"] = "export";
})(ReportConfigurationTags || (ReportConfigurationTags = {}));
export const ReportConfigurationTagsMap = {
    [ReportConfigurationSchemaIds.REPORT_CONFIGURATION]: [
        ReportConfigurationTags.DEFAULT,
        ReportConfigurationTags.EXPORT
    ]
};
export const ReportConfigurationUsageIds = usageIds(ReportConfigurationTagsMap);
